import ChatFileRowPlaceholder from './ChatFileRowPlaceholder.component';

export default ChatFileRowPlaceholder;
